import { createSlice } from "@reduxjs/toolkit";
import {getNotificationThunk} from "./thunk";


export const initialState = {
  comments: [],
  error: null,
  isLoading: false,
  notificationsList:[]
};

const NotificationSlice = createSlice({
  name: "notifications",
  initialState,
  reducers: {
    resetFlags: (state) => {
      
      state.notificationsList = [];
      state.isLoading = false;
      state.error = null;
    },
  },

  extraReducers: (builder) => {

    // Get Notifications
    builder.addCase(getNotificationThunk.pending, (state) => {
      state.isLoading = true;
      state.error = null;
    });
    builder.addCase(getNotificationThunk.fulfilled, (state, action) => {
      state.isLoading = false;
      state.notificationsList = action.payload.data;
    });
    builder.addCase(getNotificationThunk.rejected, (state, action) => {
      state.isLoading = false;
      state.notificationsList =[];
      state.error = action.payload || "Something went wrong";
    });
  },
  
});

export const { resetFlags } = NotificationSlice.actions;
export default NotificationSlice.reducer;
